import { render, staticRenderFns } from "./StepApproach.vue?vue&type=template&id=49ea3c9b&scoped=true&"
import script from "./StepApproach.vue?vue&type=script&lang=js&"
export * from "./StepApproach.vue?vue&type=script&lang=js&"
import style0 from "./StepApproach.vue?vue&type=style&index=0&id=49ea3c9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ea3c9b",
  null
  
)

export default component.exports